import {
  videoModelSpecs,
  type VideoModelCode,
} from '../video-model/model-spec';

export const REFERENCE_IMAGE_MODEL_MAP = new Map(
  videoModelSpecs
    .entries()
    .filter(([_, spec]) => !spec.deprecated)
    .filter(([_, spec]) => spec.reference_image),
);

export const DEFAULT_REFERENCE_IMAGE_MODEL: VideoModelCode =
  'dreamina_seedance_fast';
